import * as React from "react";

// NPM
import clsx from "clsx";
import { animated } from "react-spring";

// MUI
import {
	withStyles,
	WithStyles,
	createStyles,
	Theme,
} from "@material-ui/core/styles";
import { Grid, GridProps } from "@material-ui/core";

// Utility
import Utility from "../../domain/classes/Utility";

// Components
import StyledPromptedTextField from "../../components/common/PromptedTextField.Component";
import FormattedFieldSet from "../common/FormattedFieldSet.Component";
import StyledFormattedPhoneInput from "./FormattedPhoneInput.Component";

// Contexts
import { useApplicationManager } from "../../contexts/ApplicationManager.Context";

// Interfaces
import ICountryData from "../../domain/interfaces/ICountryData";

export const styles = (theme: Theme) => createStyles({ root: {} });

export interface ContactDetailsFieldsContainerV2Props extends GridProps {}

const ContactDetailsFieldsContainerV2 = React.forwardRef<
	HTMLDivElement,
	ContactDetailsFieldsContainerV2Props & WithStyles<typeof styles>
>(({ classes, className, ...gridProps }, ref) => {
	// Contexts
	const {
		handlePatientDetailsChange,
		patientDetails,
		clearPatientValidationError,
		patientValidationError,
	} = useApplicationManager();

	// States

	// handlers
	const handleMobileChange = (
		event: React.FocusEvent<HTMLInputElement>,
		data: {} | ICountryData
	) => {
		let value = event.target.value;

		const replaced = value.replace(new RegExp(/[() \-+]/, "gi"), "");

		const mobileFormat =
			(data as ICountryData).countryCode === "au" ? "aus" : "intl";

		handlePatientDetailsChange("mobile", replaced);
		handlePatientDetailsChange("mobileFormat", mobileFormat);
	};

	const handleEmailChange = (value: React.FocusEvent<HTMLInputElement>) => {
		handlePatientDetailsChange("email", value.target.value as string);
	};

	return (
		<Grid
			container
			spacing={1}
			ref={ref}
			{...gridProps}
			className={clsx(classes.root, className)}
		>
			<Grid item xs={12}>
				<FormattedFieldSet label="Contact details">
					<Grid container spacing={2}>
						<Grid item xs={12}>
							<StyledFormattedPhoneInput
								value={patientDetails.mobile}
								onPhoneChange={handleMobileChange}
								isInternationalFormat={true}
								error={!!patientValidationError.mobileError}
								onFocus={() =>
									clearPatientValidationError("mobileError")
								}
								helperText={patientValidationError.mobileError}
								disableDropdown={false}
								defaultValue={patientDetails.mobile}
							/>
						</Grid>
						<Grid item xs={12}>
							<StyledPromptedTextField
								title="Email address"
								fullWidth
								variant="outlined"
								label="Email address"
								size="small"
								onBlur={handleEmailChange}
								defaultValue={patientDetails.email}
							/>
						</Grid>
					</Grid>
				</FormattedFieldSet>
			</Grid>
		</Grid>
	);
});

const StyledContactDetailsFieldsContainerV2 = withStyles(styles, {
	classNamePrefix: Utility.generateClassName(
		"ContactDetailsFieldsContainerV2"
	),
})(ContactDetailsFieldsContainerV2);

export default StyledContactDetailsFieldsContainerV2;

export const AnimatedContactDetailsFieldsContainerV2 = animated(
	StyledContactDetailsFieldsContainerV2
);
